export default __webpack_public_path__ + "static/media/twitter.3d644da8.svg";